export const fillNumberInputValue = ({ drawerData, index, values, readOnly }) => {
    if (drawerData.length > 0 && drawerData[index]) {
      drawerData[index].state = {
        ...drawerData[index].state,
        numberValue: values.numberValue,
        mainNumberInputValue: values.numberInputValue,
        subNumberValue: values.subNumberValue,
        readOnly
      };
    }
  };
  